<template>
    <div v-if="hasResults">
        <div class="subcaption text-grey-600 px-3 mb-1">{{ props.contents.placeHolders.regions }}</div>
        <div v-for="obj in props.state.regions">
            <template v-if="obj.regions.length">
                <div class="caption text-grey-600 px-3">{{ obj.label }}</div>
                <div
                    v-for="region in obj.regions"
                    @click="handleSelect(region)"
                    class="subcaption text-grey-900 cursor-pointer py-1 item px-3 cursor-pointer d-flex justify-content-between align-items-center"
                    :class="{
                        'bg-primary-blue selected-item': isSelected(SeFields.REGION, region.id, props.store)
                    }"
                >
                    <span>{{ region.label }}</span>
                    <template v-if="isSelected(SeFields.REGION, region.id, props.store)">
                        <CloseButton />
                    </template>
                </div>
            </template>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { onMounted, computed } from 'vue'

// logic
import setSelected from '../../../logic/setSelected'
import isSelected from '../../../logic/isSelected'
import unselect from '../../../logic/unselect'

// types
import type { ComputedRef } from 'vue'

// enums
import { SeFields } from '../../../enums/seFields'

// state
import {AutocompleteState} from '../../../state/autocompleteState'

// components
import CloseButton from '../../../components/close-button.vue'

// props
const props = defineProps<{
    // regions: IConstructedRegionCountry[]
    se: any
    store: any
    contents: any
    state: AutocompleteState
}>()

// Computed

const hasResults: ComputedRef<number> = computed(() => {
    const regionLengths = props.state.regions.map((region) => {
        return region.regions.length
    })

    return regionLengths.filter((item) => item).length
})

// Methods

const handleSelect = (region: any) => {
    if (isSelected(SeFields.REGION, region.id, props.store)) {
        handleUnselect()
    } else {
        select(region)
    }
}

const select = (region: any) => {
    const { id, label } = region
    setSelected(SeFields.REGION, id, region.label, props.store)
    props.store.libs.se.batch(() => {
        props.store.libs.se.setFieldValue(SeFields.REGION, id)
        props.store.libs.se.setFieldValue(SeFields.PARENT_STATION, undefined)
        props.store.libs.se.setFieldValue(SeFields.DOMAINS, undefined)
        props.store.libs.se.setFieldValue(SeFields.STATION, undefined)
    })
}

const handleUnselect = () => {
    props.store.libs.se.setFieldValue(SeFields.REGION, undefined)
    unselect(props.store)
}

onMounted(() => {})
</script>
